import { render } from "./UtentiClienti.vue?vue&type=template&id=2bf52830"
import script from "./UtentiClienti.vue?vue&type=script&lang=js"
export * from "./UtentiClienti.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__